module.exports = __webpack_public_path__ + "static/7-a0690de59d6701d06f42d61eddcb9b32.jpg";